import React, { useState, useEffect } from 'react';
import api from '../../utils/api';
import {
    Box, Button, Collapse, FormControl, IconButton, InputLabel, MenuItem,
    Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    TextField, Typography, Menu, ListItemIcon, ListItemText, Pagination, Checkbox,
  } from '@mui/material';
import { ExpandMore, ExpandLess, Search, History, MoreVert, Add, Edit, List } from '@mui/icons-material';
import Navbar from '../Layouts/Navbar';
import Snackbar from '@mui/material/Snackbar';
import AltRouteIcon from "@mui/icons-material/AltRoute";
import MuiAlert from '@mui/material/Alert';
import HistoriqueModal from './HistoriqueModal';
import DeleteIcon from '@mui/icons-material/Delete';
import AddModal from './AddModal';
import UpdateModal from './UpdateModal';
import { Link } from 'react-router-dom';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';



export default function TrajeTable() {
  const [openhis, setOpenHis] = useState(false);
  const handleOpenHis = () => setOpenHis(true);
  const handleCloseHis = () => setOpenHis(false);

  const [openadd, setOpenAdd] = useState(false);
  const handleOpenAdd = () => setOpenAdd(true);
  const handleCloseAdd = () => setOpenAdd(false);

  const [openupd, setOpenUpd] = useState(false);
  const handleOpenUpd = () => setOpenUpd(true);
  const handleCloseUpd = () => setOpenUpd(false);




  const [snack, setSnack] = useState({ open: false, message: '', type: 'success' });
  const handleSnack = (message, type = 'success') => {
    setSnack({ open: true, message, type });
  };
  
  const handleCloseSnack = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnack({ ...snack, open: false });
  };

  const [open, setOpen] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const [menuRowId, setMenuRowId] = useState(null);

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(1);
  
  // State for selected rows/checkboxes
  const [selected, setSelected] = useState([]);
  const [groupAction, setGroupAction] = useState('');
  
  // State for data
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sites, setSites] = useState([]);
  const [selectedTrajet, setSelectedTrajet] = useState(null);
  
  // Search states
  const [searchKeyword, setSearchKeyword] = useState('');
  const [searchSite, setSearchSite] = useState('');
  const [searchStatus, setSearchStatus] = useState('');
  
  // Fetch trajets from API
  const fetchTrajets = async () => {
    try {
      setLoading(true);
      const response = await api.get('/trajets');
      setRows(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching trajets:', error);
      handleSnack('Erreur lors du chargement des trajets', 'error');
      setLoading(false);
    }
  };
  
  // Fetch sites from API
  const fetchSites = async () => {
    try {
      const response = await api.get('/sites');
      setSites(response.data);
    } catch (error) {
      console.error('Error fetching sites:', error);
    }
  };
  

  
  // Load data on component mount
  useEffect(() => {
    fetchTrajets();
    fetchSites();
  }, []);
  
  
  

  const handleDelete = async () => {
    try {
      if (menuRowId) {
        const response = await api.delete(`/trajets/${menuRowId}`);
        handleSnack('Trajet supprimé avec succès', 'success');
        fetchTrajets(); // Refresh the list
      }
      handleMenuClose();
    } catch (error) {
      console.error('Error deleting trajet:', error);
      
      // Gestion détaillée des erreurs
      if (error.response) {
        if (error.response.status === 404) {
          handleSnack("Le trajet n'a pas été trouvé ou a déjà été supprimé", 'error');
        } else if (error.response.status === 403) {
          handleSnack("Vous n'avez pas les droits nécessaires pour supprimer ce trajet", 'error');
        } else if (error.response.status === 500) {
          handleSnack("Erreur serveur lors de la suppression du trajet", 'error');
        } else {
          handleSnack(error.response.data?.message || "Erreur lors de la suppression du trajet", 'error');
        }
      } else {
        // Erreur réseau
        handleSnack("Erreur de connexion au serveur. Veuillez vérifier votre connexion internet.", 'error');
      }
    } finally {
      handleMenuClose();
    }
  };

  const handleModify = () => {
    try {
      // Modify logic would go here
      handleSnack('Réservation modifiée avec succès', 'success');
      handleMenuClose();
    } catch (error) {
      handleSnack("Erreur lors de la modification de la réservation", 'error');
    }
  };
  
  const handleDuplicate = async () => {
    try {
      if (menuRowId) {
        // Find the trajet to duplicate
        const trajetToDuplicate = rows.find(row => row.ID_Trajet === menuRowId);
        
        if (trajetToDuplicate) {
          // Create a new trajet object with the same properties but a modified name
          const newTrajet = {
            ...trajetToDuplicate,
            name: `${trajetToDuplicate.name} - Copy`,
            // Remove the ID so the API will create a new record
            ID_Trajet: undefined
          };
          
          // Send the new trajet to the API
          await api.post('/trajets', newTrajet);
          handleSnack('Trajet dupliqué avec succès', 'success');
          fetchTrajets(); // Refresh the list
        }
      }
      handleMenuClose();
    } catch (error) {
      console.error('Error duplicating trajet:', error);
      handleSnack("Erreur lors de la duplication du trajet", 'error');
    }
  };

  const handleMenuClick = (event, id) => {
    setAnchorEl(event.currentTarget);
    setMenuRowId(id);
    
    // Find the selected trajet for update modal
    const trajet = rows.find(row => row.ID_Trajet === id);
    setSelectedTrajet(trajet);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuRowId(null);
  };

  const handleChangePage = (event, value) => {
    setPage(value);
  };

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(1);
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map(n => n.ID_Trajet);
      setSelected(newSelected);
    } else {
      setSelected([]);
    }
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];
    
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    
    setSelected(newSelected);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  const handleGroupAction = async () => {
    if (groupAction === 'Supprimer' && selected.length > 0) {
      try {
        // Delete multiple trajets using Promise.allSettled pour gérer les succès/échecs individuels
        const deletePromises = selected.map(id => api.delete(`/trajets/${id}`));
        const results = await Promise.allSettled(deletePromises);
        
        // Compter les succès et les échecs
        const successCount = results.filter(result => result.status === 'fulfilled').length;
        const failureCount = results.filter(result => result.status === 'rejected').length;
        
        // Message adapté en fonction des résultats
        if (successCount > 0 && failureCount === 0) {
          handleSnack(`${successCount} trajet(s) supprimé(s) avec succès`, 'success');
        } else if (successCount > 0 && failureCount > 0) {
          handleSnack(`${successCount} trajet(s) supprimé(s), ${failureCount} échec(s)`, 'warning');
        } else {
          handleSnack('Échec de la suppression des trajets', 'error');
        }
        
        setSelected([]);
        setGroupAction('');
        fetchTrajets(); // Refresh the list
      } catch (error) {
        console.error('Error deleting trajets:', error);
        
        // Gestion détaillée des erreurs
        if (error.response && error.response.status === 500) {
          handleSnack('Erreur serveur lors de la suppression des trajets', 'error');
        } else {
          handleSnack('Erreur lors de la suppression des trajets. Veuillez réessayer.', 'error');
        }
      }
    }
  };
  
  // Handle search
  const handleSearch = () => {
    // Search is handled by the filteredRows computation
  };
  
  // Handle reset search
  const handleReset = () => {
    setSearchKeyword('');
    setSearchSite('');
    setSearchStatus('');
  };

  // Filter rows based on search criteria
  const filteredRows = rows.filter(row => {
    const matchesKeyword = searchKeyword ? 
      row.name?.toLowerCase().includes(searchKeyword.toLowerCase()) : true;
    
    const matchesSite = searchSite ? 
      row.ID_Site === parseInt(searchSite) : true;
    
    const matchesStatus = searchStatus ? 
      row.Status?.toLowerCase() === searchStatus.toLowerCase() : true;
    
    return matchesKeyword && matchesSite && matchesStatus;
  });
  
  const paginatedRows = filteredRows.slice((page - 1) * rowsPerPage, page * rowsPerPage);
  const pageCount = Math.ceil(filteredRows.length / rowsPerPage);

  return (
    <Box>
      <Navbar />
      <Box p={2}>
        {/* Header */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Box display="flex" alignItems="center" onClick={() => setOpen(!open)} sx={{ cursor: 'pointer' }}>
            <AltRouteIcon />
            <Typography variant="h6">TRAJETS</Typography>
          </Box>
          <Box display="flex" gap={2}>
            <Button variant="outlined"
             onClick={handleOpenAdd}
            sx={{
              color: 'red',
              borderColor: 'red',
              textTransform: 'none',
              '&:hover': { backgroundColor: 'red', color: '#fff', borderColor: 'red' },
            }} startIcon={<Add />}>Ajouter</Button>
          </Box>
        </Box>
          {/* Search Section */}
          <Paper variant="outlined" sx={{ mb: 3 }}>
          <Box display="flex" alignItems="center" gap={1} mb={1} mt={1} onClick={() => setOpen(!open)} sx={{ cursor: 'pointer' }}>
            <Search />
            <Typography variant="h6" sx={{ flexGrow: 1 }}>RECHERCHER</Typography>
            <IconButton>{open ? <ExpandLess /> : <ExpandMore />}</IconButton>
          </Box>
        </Paper>

        <Collapse in={open}>
          <Paper variant="outlined" sx={{ p: 2, mb: 3 }}>
            <Box display="flex" gap={2} mb={2}>
            <TextField
                label="Mot cle"
                InputLabelProps={{ shrink: true }}
                fullWidth size="small"
                value={searchKeyword}
                onChange={(e) => setSearchKeyword(e.target.value)}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': { borderColor: '#000' },
                    '&.Mui-focused fieldset': { borderColor: 'red' },
                  },
                  '& .MuiInputLabel-root': {
                    '&.Mui-focused': { color: 'red' },
                    '&:hover': { color: '#000' },
                  }
                }}
              />
              <FormControl fullWidth size="small" sx={{
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': { borderColor: '#000' },
                  '&.Mui-focused fieldset': { borderColor: 'red' },
                }
              }}>
                <InputLabel sx={{
                  '&.Mui-focused': { color: 'red' },
                  '&:hover': { color: '#000' },
                }}>Site</InputLabel>
                <Select 
                  label="Site"
                  value={searchSite}
                  onChange={(e) => setSearchSite(e.target.value)}
                >
                  <MenuItem value="">Tous</MenuItem>
                  {sites.map((site) => (
                    <MenuItem key={site.ID_Site} value={site.ID_Site}>
                      {site.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth size="small" sx={{
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': { borderColor: '#000' },
                  '&.Mui-focused fieldset': { borderColor: 'red' },
                }
              }}>
                <InputLabel sx={{
                  '&.Mui-focused': { color: 'red' },
                  '&:hover': { color: '#000' },
                }}>Status</InputLabel>
                <Select 
                  label="Statut"
                  value={searchStatus}
                  onChange={(e) => setSearchStatus(e.target.value)}
                >
                  <MenuItem value="">Tous</MenuItem>
                  <MenuItem value="Active">Actif</MenuItem>
                  <MenuItem value="Inactive">Inactif</MenuItem>
                </Select>
              </FormControl>
            </Box>
            <Box display="flex" justifyContent="space-between" gap={2}>
              <Button 
                variant="outlined" 
                onClick={handleReset}
                sx={{
                  color: 'red',
                  borderColor: 'red',
                  textTransform: 'none',
                  '&:hover': { backgroundColor: 'red', color: '#fff', borderColor: 'red' },
                }}
              >
                Reset
              </Button>
              <Button 
                variant="outlined" 
                onClick={handleSearch}
                sx={{
                  color: 'red',
                  borderColor: 'red',
                  textTransform: 'none',
                  '&:hover': { backgroundColor: 'red', color: '#fff', borderColor: 'red' },
                }}
              >
                Search
              </Button>
            </Box>
          </Paper>
        </Collapse>


        {/* Bulk Actions */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Box display="flex" alignItems="center" gap={2}>
            <Typography>Actions groupées</Typography>
            <FormControl size="small" sx={{
                minWidth: 150 ,
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': { borderColor: '#000' },
                  '&.Mui-focused fieldset': { borderColor: 'red' },
                }
              }}>
              <Select
                value={groupAction}
                onChange={(e) => setGroupAction(e.target.value)}
                displayEmpty
              >
                <MenuItem value="" disabled><em>Sélectionner</em></MenuItem>
                <MenuItem value="Supprimer">Supprimer</MenuItem>
              </Select>
            </FormControl>
            <Button
              variant="contained"
              disabled={!groupAction || selected.length === 0}
              onClick={handleGroupAction}
              sx={{
                bgcolor: 'red',
                textTransform: 'none',
                '&:hover': { bgcolor: 'red' },
                '&.Mui-disabled': { bgcolor: '#f5f5f5', color: '#bdbdbd' }
              }}
            >
              Appliquer
            </Button>
          </Box>
          <Typography>{selected.length} sélectionnés / {filteredRows.length} entrées</Typography>
        </Box>

        {/* Table */}
        <TableContainer component={Paper} variant="outlined">
            <Table>
                <TableHead>
                <TableRow>
                    <TableCell padding="checkbox">
                    <Checkbox
                        indeterminate={selected.length > 0 && selected.length < rows.length}
                        checked={rows.length > 0 && selected.length === rows.length}
                        onChange={handleSelectAll}
                        sx={{
                        '&.MuiCheckbox-indeterminate': { color: '#000' },
                        '&.Mui-checked': { color: '#000' },
                        }}
                    />
                    </TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Nom</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>État</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Actions</TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                {paginatedRows.map((row) => {
                    const isItemSelected = isSelected(row.ID_Trajet);
                    return (
                    <TableRow key={row.ID_Trajet} hover selected={isItemSelected}>
                        <TableCell padding="checkbox">
                        <Checkbox
                            checked={isItemSelected}
                            onChange={(event) => handleSelectOne(event, row.ID_Trajet)}
                            sx={{
                            '&.MuiCheckbox-indeterminate': { color: '#000' },
                            '&.Mui-checked': { color: '#000' },
                            }}
                        />
                        </TableCell>
                        <TableCell>{row.name}</TableCell>
                        <TableCell>
                        <Box
                            sx={{
                            backgroundColor: row.Status === 'active' || row.Status === 'Active' ? '#4caf50' : '#dc3545',
                            color: 'white',
                            borderRadius: '4px',
                            px: 1,
                            py: 0.5,
                            display: 'inline-block',
                            fontSize: '0.8rem',
                            textAlign: 'center',
                            minWidth: '60px',
                            }}
                        >
                            {row.Status === 'Active' ? 'Actif' : 'Inactif'}
                        </Box>
                        </TableCell>
                        <TableCell>
                        <IconButton onClick={(e) => handleMenuClick(e, row.ID_Trajet)}>
                            <MoreVert />
                        </IconButton>
                        <Menu
                            anchorEl={anchorEl}
                            open={menuRowId === row.ID_Trajet && openMenu}
                            onClose={handleMenuClose}
                            PaperProps={{
                            sx: {
                                minWidth: '200px',
                                '& .MuiMenuItem-root': {
                                color: 'black',
                                '& .MuiListItemIcon-root': { color: 'black' },
                                '&:hover': {
                                    backgroundColor: 'red',
                                    color: 'white',
                                    '& .MuiListItemIcon-root': { color: 'white' },
                                },
                                },
                            },
                            }}
                        >
                            <MenuItem component={Link} to={`/detail-trajets?id=${row.ID_Trajet}`}>
                            <ListItemIcon><List fontSize="small" /></ListItemIcon>
                            <ListItemText>Détail</ListItemText>
                            </MenuItem>
                            <MenuItem onClick={handleOpenUpd}>
                            <ListItemIcon><Edit fontSize="small" /></ListItemIcon>
                            <ListItemText>Modifier</ListItemText>
                            </MenuItem>
                            <MenuItem onClick={handleDuplicate}>
                            <ListItemIcon><ContentCopyIcon fontSize="small" /></ListItemIcon>
                            <ListItemText>Dupliquer</ListItemText>
                            </MenuItem>
                            <MenuItem sx={{ color: 'red' }} onClick={handleOpenHis}>
                            <ListItemIcon sx={{ color: 'red' }}><History fontSize="small" /></ListItemIcon>
                            <ListItemText>Historique</ListItemText>
                            </MenuItem>
                            <MenuItem sx={{ color: 'red' }} onClick={handleDelete}>
                            <ListItemIcon sx={{ color: 'red' }}><DeleteIcon fontSize="small" /></ListItemIcon>
                            <ListItemText>Supprimer</ListItemText>
                            </MenuItem>
                        </Menu>
                        </TableCell>
                    </TableRow>
                    );
                })}
                </TableBody>
            </Table>
            </TableContainer>


        {/* Pagination */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
          <Typography>{filteredRows.length} entrées</Typography>
          <Box display="flex" gap={2} alignItems="center">
            <FormControl size="small" sx={{
              '& .MuiOutlinedInput-root': {
                '&:hover fieldset': { borderColor: '#000' },
                '&.Mui-focused fieldset': { borderColor: 'red' },
              }
            }}>
              <Select value={rowsPerPage} onChange={handleChangeRowsPerPage}>
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={25}>25</MenuItem>
                <MenuItem value={50}>50</MenuItem>
              </Select>
            </FormControl>
            <Pagination
              count={pageCount}
              page={page}
              onChange={handleChangePage}
              variant="outlined"
              shape="rounded"
            />
          </Box>
        </Box>
      </Box>

      <Snackbar 
        open={snack.open} 
        autoHideDuration={3000} 
        onClose={handleCloseSnack} 
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <MuiAlert 
          onClose={handleCloseSnack} 
          severity={snack.type} 
          elevation={6} 
          variant="filled" 
          sx={{ width: '100%', bgcolor: snack.type === 'success' ? 'green' : 'red' }}
        >
          {snack.message}
        </MuiAlert>
      </Snackbar>

    <HistoriqueModal open={openhis} handleClose={handleCloseHis} />
    <AddModal 
      open={openadd} 
      handleClose={handleCloseAdd} 
      handleSnack={handleSnack} 
      onSuccess={fetchTrajets} 
      sites={sites}
    />
    <UpdateModal 
      open={openupd} 
      handleClose={handleCloseUpd} 
      handleSnack={handleSnack} 
      onSuccess={fetchTrajets} 
      selectedRow={selectedTrajet}
      sites={sites}
    />
    </Box>
  );
}